module.exports = __webpack_public_path__ + "static/media/fms4.1d5943ce.png";